import React from 'react';
import { Box } from '@sparrowengg/twigs-react';
import Navbar from 'commons/components/navbar';
import EventLogs from 'features/event-logs/components';

const EventLogsPage = () => {
  return (
    <Box css={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <Navbar showPreviousBtn />
      <EventLogs />
    </Box>
  );
};

export default EventLogsPage;
